import { render, staticRenderFns } from "./UploadedGamesWidget.vue?vue&type=template&id=94729c2a"
import script from "./UploadedGamesWidget.vue?vue&type=script&lang=js"
export * from "./UploadedGamesWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports